import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux"
import { searchConstructionMedia } from "../../actions/videoInput";
import { selectMediaLibaryVideo, selectMediaLibaryVideoCount } from "../../actions/selectors";
import { LibaryMediaType } from "../../types/constructionMedia";
import OverlayImage from "../../components/OverlayImage";
import HeibaLibaryItem from "../../components/admin/HeibaLibaryItem";
import SearchField from "../../components/admin/SearchField";
import { Pagination } from "semantic-ui-react";

export default function HeibaLibary() {
  const constructionVideo = useAppSelector(selectMediaLibaryVideo );
  const constructionVideoCount = useAppSelector(selectMediaLibaryVideoCount);
  const dispatch = useAppDispatch();
  const [type] = useState<LibaryMediaType>("vlees"); 
  // const [type, set_type] = useState<LibaryMediaType>("vlees");
  const [searchTerms, set_searchTerms] = useState<undefined| string>(undefined) 
  const [showLarge, set_showLarge] = useState(false);
  const [imgUrl, set_imgUrl] = useState("");
  const [currentPage, set_currentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  useEffect(() => {
    // dispatch(getConstructionMedia(type, undefined));
    const offset = currentPage !== 1 ? (currentPage ) * itemsPerPage : 0
    dispatch(searchConstructionMedia({limit: itemsPerPage, offset, search: searchTerms || "", memberCategory: type}));
  }, [type, dispatch, itemsPerPage, currentPage, searchTerms]);

  const handleTyping = (s:string)=> {
      set_searchTerms(s)
    }
    const handleSearch = () => {
      dispatch(searchConstructionMedia({limit: itemsPerPage, offset: 0 , search: searchTerms || "", memberCategory: type}));
    }
    const handlePageChange = (_:any, {activePage}:any) => {
      set_currentPage(activePage)
    }
  return (
    <div>
      <SearchField searchText={searchTerms} handleTyping={handleTyping} handleSearch={handleSearch} />
      {showLarge ?   
      <OverlayImage
          src={imgUrl}
          showLarge={set_showLarge}
        /> : null }
      <div style={{  display: 'flex', flexFlow: 'wrap'}}>
      {
      constructionVideo.map((video) => {
        if (!video) return null;
        if (!video.link) return null;
        return (
           <HeibaLibaryItem
            key={video.id}
            mediaItem={video}
            set_showLarge={set_showLarge}
            set_imgUrl={set_imgUrl}
            showLarge={showLarge}
            mediaType="video"
            />
        );
      })}
      </div>
      <Pagination defaultActivePage={currentPage} totalPages={Math.ceil((constructionVideoCount? constructionVideoCount : 1 )/itemsPerPage)} onPageChange={handlePageChange} />
    </div>
  );
}
